import { validateNumber } from 'ember-changeset-validations/validators';

export const MlosLeadTimeRuleValidation = {
  threshold: validateNumber({ gte: 1, integer: true, allowBlank: false }),
  mlosValue: validateNumber({ gte: 1, integer: true, allowBlank: false }),
};
